import { useBuilder } from '@/lib/builder/extension/useBuilder'

import type { SelectSection } from '../../../../types/FormBuilder.types'

const formBuilderQueue = useBuilder('formBuilder')

const SelectCommands = {
  updateBlock: formBuilderQueue.createBlockCommand<SelectSection>({
    commit: async (currentData, ctx) => {
      return {
        ...currentData,
        ...ctx.update,
        params: { ...currentData.params, ...ctx.update.params },
      }
    },
  }),
}

export { SelectCommands }
